import { useState, useCallback } from 'react';
import { SEKTOR_YAPILANDIRMASI } from '../utils/compressorConfig';

export const useAdvancedForm = () => {
  const [form, setForm] = useState({
    sektor: '', altKategoriKey: '', makineSayisi: 1,
    makineTuketimM3dk: '', toplamTuketimM3dk: '',
    calismaBasinci: '', calismaTipi: 'sürekli',
    buyumeOrani: 10, cigNoktasi: '', firma: '', yetkili: '',
    elektrikFiyati: '', calismaSaati: 6000, ortalamaYuk: 75,
    hatUzunluk: 50, boruCapi: 2,
    loadRatio: 0.75, unloadPowerFactor: 0.25, cycleTime: '',
    kacakOrani: 10, redundancyMode: 'otomatik',
    verimlilikFaktoru: 1.0,
    auditMode: false,
    existingCapacityM3dk: '',
    measuredConsumptionM3dk: '',
    currentEnergyCost: '',
    kompresorTipi: 'otomatik',
    vsdPremiumOverride: '',
    analysisPeriod: 10
  });

  const [errors, setErrors] = useState({});

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    const numericFields = [
      'makineSayisi', 'makineTuketimM3dk', 'toplamTuketimM3dk', 
      'calismaBasinci', 'buyumeOrani', 'cigNoktasi', 'elektrikFiyati', 
      'calismaSaati', 'ortalamaYuk', 'hatUzunluk', 'boruCapi', 
      'loadRatio', 'unloadPowerFactor', 'cycleTime', 'kacakOrani',
      'verimlilikFaktoru', 'existingCapacityM3dk', 'measuredConsumptionM3dk', 
      'currentEnergyCost', 'vsdPremiumOverride', 'analysisPeriod'
    ];
    const stringFields = ['sektor', 'altKategoriKey', 'calismaTipi', 'redundancyMode', 'kompresorTipi'];
    
    const parsed = numericFields.includes(name) 
      ? (value === '' ? '' : Number(value)) 
      : stringFields.includes(name) 
        ? value 
        : value;

    setForm(prev => {
      const next = { ...prev, [name]: parsed };
      if (name === 'sektor') {
        next.altKategoriKey = ''; next.calismaBasinci = ''; next.cigNoktasi = '';
      } else if (name === 'altKategoriKey' && value) {
        const config = SEKTOR_YAPILANDIRMASI[value];
        if (config) { next.calismaBasinci = config.basinc; next.cigNoktasi = config.cig; }
      }
      return next;
    });
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  }, [errors]);

  const validate = useCallback(() => {
    const errs = {};
    const tuketim = form.toplamTuketimM3dk > 0 ? form.toplamTuketimM3dk : (form.makineTuketimM3dk * form.makineSayisi);
    if (!form.sektor) errs.sektor = '⚠️ Sektör seçimi zorunludur.';
    if (!form.altKategoriKey) errs.altKategoriKey = '⚠️ Kullanım alanı seçimi zorunludur.';
    if (!tuketim || tuketim <= 0) errs.tuketim = '⚠️ Tüketim girilmelidir.';
    setErrors(errs); return Object.keys(errs).length === 0;
  }, [form]);

  const reset = useCallback(() => {
    setForm({ 
      sektor: '', altKategoriKey: '', makineSayisi: 1,
      makineTuketimM3dk: '', toplamTuketimM3dk: '',
      calismaBasinci: '', calismaTipi: 'sürekli',
      buyumeOrani: 10, cigNoktasi: '', firma: '', yetkili: '',
      elektrikFiyati: '', calismaSaati: 6000, ortalamaYuk: 75,
      hatUzunluk: 50, boruCapi: 2,
      loadRatio: 0.75, unloadPowerFactor: 0.25, cycleTime: '',
      kacakOrani: 10, redundancyMode: 'otomatik',
      verimlilikFaktoru: 1.0,
      auditMode: false, existingCapacityM3dk: '', measuredConsumptionM3dk: '', currentEnergyCost: '',
      kompresorTipi: 'otomatik', vsdPremiumOverride: '', analysisPeriod: 10
    });
    setErrors({});
  }, []);

  return { form, errors, handleChange, validate, reset, setForm, setErrors };
};